import { InsuranceDetails, cardDetail, loanDetail } from './../Services/account.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../Services/account.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { Subject } from "rxjs";
import { RewardsService } from '../loyalty-points/rewardservice/rewards.service';
import { SettingService } from '../Services/setting.service';
import { CookieService } from '../Services/cookie';
import { TicketService } from '../Services/ticket.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  standalone:false,
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  LoyaltyCards;
  cardDetail: cardDetail;
  loanDetail: loanDetail;
  InsuranceDetail: InsuranceDetails;
  loyalityPoints: number = 0;
  url: string = "";
  serviceType: string
  activeTab: number = 2;
  payNowBtnStatus: number = null;
  ticketnumber: any;
  ticketID: any;
  cpr: string;
  pendingApplication: any = {};
  isPendingApplicationEmpty: any;
  serviceType2: string;
  constructor(
    public commonP: CommonService,
    public auth: AuthService,
    public account: AccountService,
    private _router: Router,
    private reward: RewardsService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private setting: SettingService,
    private tick: TicketService
  ) { }

  showModal(num) {
    this.modalObservable.next(num);
  }

  activeTab1: number;
  changeTab1(e) {
    this.activeTab1 = e;
    if (this.activeTab1 === 1) {
      this.serviceType2 = "Islamic";
      this.userStatus()
    } else if (this.activeTab1 === 2) {
      this.serviceType2 = "Conventional";
      this.userStatus()
    }
  }



  async ngOnInit(): Promise<void> {
    this.serviceType = await this.cookieService.get("sTyp", true);
    console.log("serviceTypeData", this.serviceType);
    if (this.serviceType === 'Islamic') {
      this.activeTab1 = 1;
    } else if (this.serviceType === 'Conventional') {
      this.activeTab1 = 2;
    } else {
      this.activeTab1 = 1; // default value agar kuch bhi match na kare
    }
    // setTimeout(() => {
    //   this.showModal(1)
    // }, 1000);
    this.cookieService.set(
      "isps2esd",
      "",
      true
    );
    if (localStorage.getItem("selectedLanguage") == "ar") {
      this.activeTab = 1;
    } else {
      this.activeTab = 2;
    }
    this.cpr = await this.cookieService.get(
      "tempValue",
      true
    );
    console.log("123cpr", this.cpr);

    this.auth.accessToken = await this.commonP.Get("token");
    await this.commonP.presentLoading();
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            await this.GetAllPendingApplications();
            this.auth.detailuser = data?.response?.content;
            console.log("detailuser", this.auth.detailuser);
            this.account
              .GetLoanDashboard(this.auth.accessToken)
              .then((data: any) => {
                if (data?.response?.code == 1) {
                  // this.commonP.hideLoading();
                  let CardDetails = data.response.content.cardDetails.filter(
                    (x) => x.primaryOrSupplementary == "Y"
                  );
                  let LoanDetails = data.response.content.loanDetails;
                  let InsuranceDet = data.response.content.insuranceDetails;
                  this.ticketnumber = data.response.content.ticketNumber;
                  this.ticketID = data.response.content.userTicketId;

                  this.reward
                    .GetRewardsSummary(this.auth.accessToken)
                    .then(async (data: any) => {
                      if (data?.response?.code == 1) {
                        console.log(" GetRewardsSummary", data);
                        this.commonP.hideLoading();
                        await Promise.all([
                          this.getAvatar(),
                          this.TicketStatus(),
                        ]);
                        this.LoyaltyCards = data.response.content;
                        console.log(" this.LoyaltyCards", this.LoyaltyCards);
                        let points = [];
                        data?.response?.content.forEach((x) => {
                          points.push(Number(x.rewardsBalance));
                        });
                        this.loyalityPoints = points.reduce(
                          (accumulator, currentvalue) => {
                            return accumulator + currentvalue;
                          },
                          0
                        );
                        console.log("this.loyalityPoints", this.loyalityPoints);
                      } else {
                        this.commonP.hideLoading();
                        this.commonP.ParseErrorAlert(
                          "",
                          "",
                          this._router,
                          data
                        );
                      }
                    });

                  console.log("AllCardDetails", CardDetails);
                  console.log("AllLoanDetails", LoanDetails);
                  console.log("AllInsuranceDetails", InsuranceDet);

                  console.log(
                    "CardDetails",
                    CardDetails.filter((x) => x.displayFlag == "Y")
                  );
                  console.log(
                    "LoanDetails",
                    LoanDetails.filter((x) => x.displayFlag == "Y")
                  );

                  this.cardDetail = CardDetails.filter(
                    (x) =>
                      x.displayFlag == "Y" && x.primaryOrSupplementary == "Y"
                  );
                  this.loanDetail = LoanDetails.filter(
                    (x) => x.displayFlag == "Y"
                  );
                  this.InsuranceDetail = InsuranceDet.filter(
                    (x) => x.displayFlag == "Y"
                  );
                } else {
                  this.commonP.hideLoading();
                  this.commonP.ParseErrorAlert("", "", this._router, data);
                }
              });
          } else {
            await this.commonP.hideLoading();

            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.commonP.hideLoading();

          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }
  checkAmount(amount) {
    if (Number(amount) > 0) {
      return amount;
    } else {
      return "0";
    }
  }

  showPayNowBtn(index) {
    this.payNowBtnStatus = index;
  }

  getAvatar() {
    this.commonP.presentLoading();
    this.setting.GetAvatar(this.auth.accessToken, {}).then((data: any) => {
      if (data?.response?.code == 1) {
        if (data?.response?.content.response) {
          let prefix = "data:image/jpeg;base64,";
          this.url = prefix.concat(data?.response?.content.response);
          console.log("Image", this.url);
          this.commonP.hideLoading();
        } else {
          this.url = data?.response?.content.response;
          console.log("Image", this.url);
          this.commonP.hideLoading();
        }
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
  }
  RewardsLoyaltyPoints() {
    this._router.navigateByUrl("/LoyaltyPoints");
  }

  PayCard(internalId, type, max) {
    this.cookieService.set(
      "prodType",
      type,
      true
    );
    this.cookieService.set(
      "InternalId",
      internalId,
      true
    );
    this.cookieService.set(
      "amountdetail",
      "",
   true
    );
    this.cookieService.set(
      "flow",
      "",
  true
    );
    this.cookieService.set(
      "MaxPayment",
      max,
true
    );

    this._router.navigateByUrl("/PayCard");
  }

  CardDash(internalId, p) {
    this.cookieService.set(
      "InternalId",
      internalId,
  true
    );
    this.cookieService.set(
      "Home",
      p,
  true
    );

    this._router.navigateByUrl("/DashboardCreditCards");
  }

  LoanDash(internalId, p) {

    this.cookieService.set(
      "InternalId",
      internalId,
   true
    );
    this.cookieService.set(
      "Home",
      p,
     true
    );

    this._router.navigateByUrl("/DashboardLoans");
  }

  TicketStatus() {
    if (this.account?.getDashboardDetail?.userTicketId != "") {
      let body = {
        UniqueId: this.commonP.Guid(),
        CPR: this.cpr,
        UserTicketId: this.account?.getDashboardDetail?.userTicketId,
      };
      // new this.auth.accessToken add kara hai for tokken
      this.tick
        .CheckVisitStatus(body, this.auth.accessToken)
        .then((data: any) => {
          if (data?.response?.code == 1) {
            console.log("yousuf1");

            this.account.CheckVstStatus = data.response.content;
            //this.userTicketId = this.CheckVstStatus.userTicketId;

            console.log("CheckVstStatusResponse", this.account.CheckVstStatus);
            this.commonP.hideLoading();
          } else {
            this.commonP.hideLoading();
            // this.commonP.ParseErrorAlert("", "OK", this._router, data);
          }
        });
    }
  }

  async GetAllPendingApplications() {
    // if(this.account?.getDashboardDetail?.userTicketId != ""){

    let body = {
      Type: "",
    };
    // new this.auth.accessToken add kara hai for tokken
    this.account
      .GetAllPendingApplications(body, this.auth.accessToken)
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.pendingApplication = data?.response?.content;
          console.log("pendingData", this.pendingApplication);

          this.isPendingApplicationEmpty = this.isAllEmpty(
            this.pendingApplication
          );
          console.log("GetAllPendingApp", data);

          // this.commonP.hideLoading();
        } else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "OK", this._router, data);
        }
      });
    // }
  }

  // isAllEmpty(content: any): boolean {
  //   if (!content) {
  //     return true;
  //   }
  //   return (
  //     (content.cardDetails?.length || 0) === 0 &&
  //     (content.insuranceDetails?.length || 0) === 0 &&
  //     (content.loanDetails?.length || 0) === 0 &&
  //     (content.prePaidCardDetails?.length || 0) === 0
  //   );
  // }

  isAllEmpty(content: any): boolean {
    if (!content || content.length === 0) {
      return true; // Empty array or null/undefined
    }
    return false; // Data is present
  }

  redirectToLoanPage() {
    window.open("https://www.bahraincredit.com.bh/Loans/", "_blank");
  }

  redirectToCarPage() {
    window.open("https://www.bahraincredit.com.bh/Loans/CarLoan/", "_blank");
  }

  redirectToCardsPage() {
    window.open("https://www.bahraincredit.com.bh/Cards/", "_blank");
  }

  redirectToInsurancePage() {
    window.open("https://www.bahraincredit.com.bh/Insurance/", "_blank");
  }

  changeTab(e: number) {
    //

    this.activeTab = e;
    // local ka code yousuf
    this.activeTab = e;
    const selectedLang = e === 1 ? "ar" : "en";
    // Update language and save the selection in localStorage
    this.translate.use(selectedLang);
    localStorage.setItem("selectedLanguage", selectedLang);
    //
    if (e === 1) {
      // Switch to Arabic
      this.translate.use("ar");
      document.documentElement.setAttribute("lang", "ar");
    } else if (e === 2) {
      // Switch to English
      this.translate.use("en");
      document.documentElement.setAttribute("lang", "en");
    }
  }


  userStatus() {
    let body = {
      ServiceType: this.serviceType2
    }
    this.commonP.presentLoading();
    this.account.UpdateServiceMode(body, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("UpdateServiceModesucess", data);
          await this.getService()
          // await this.commonP.hideLoading();

        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  async getService() {
    // await this.CommonService.presentLoading();
    this.account.GetServiceType({}, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("GetServiceTypesucess", data);
          this.serviceType = data?.response?.content?.serviceType
          this.cookieService.set(
            "sTyp",
            this.serviceType,
            true,
          );
          // await this.commonP.hideLoading();
          // if (this.serviceType === "None") {
          // this._router.navigateByUrl("/SelectService");
          // } else {
          // this._router.navigateByUrl("/Dashboard");
          // }
          window.location.reload()
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      });
  }








}
